import * as React from "react";

const SvgComponent = ({
  bg = "transparent",
  color = "#FFFFFF",
  stroke = "#FFFFFF",
  ...props
}) => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Background */}
    <rect
      x={2}
      y={2}
      width={96}
      height={96}
      rx={12}
      fill={bg}
    />

    {/* Rounded square border */}
    <rect
      x={2}
      y={2}
      width={96}
      height={96}
      rx={12}
      fill="none"
      stroke={stroke}
      strokeWidth={3}
    />

    {/* Padded icon */}
    <g transform="translate(12 12) scale(0.76)">
      {/* Battery */}
      <path
        d="M7 38.5H83.5C85.433 38.5 87 40.067 87 42V82C87 83.933 85.433 85.5 83.5 85.5H7C5.067 85.5 3.5 83.933 3.5 82V42C3.5 40.067 5.067 38.5 7 38.5Z"
        stroke={stroke}
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* Battery terminal */}
      <path
        d="M87 51H92.5C94.433 51 96 52.567 96 54.5V69.5C96 71.433 94.433 73 92.5 73H87"
        stroke={stroke}
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* Leaf */}
      <path
        d="M30 77C30.8 61.5 34.5 45.5 43.5 32.5C49 24.5 55.5 18.5 62.5 15.5C65 28 64.5 39.5 59.5 49.5C53.5 61.5 43 68.5 30 77Z"
        fill={color}
        stroke={stroke}
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Leaf vein */}
      <path
        d="M30.5 76.5C37 62 44 49.5 56.5 36"
        stroke={bg === "transparent" ? "#000000" : bg}
        strokeWidth={1.8}
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default SvgComponent;
